import {
  Button,
  Card,
  CardActions,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import { Pagination } from '@material-ui/lab'

import clsx from 'clsx'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'

import { ERROR_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import AsterChip from 'asterX-UI/DataDisplay/AsterChip'
import { CloseIcon } from 'asterX-UI/Icons'
import { EditIcon } from 'asterX-UI/Icons/EditIcon'
import AsterTypography from 'asterX-UI/Typography/AsterTypography'

import { NotFound } from 'components/NotFound'
import { RopWLFilterMobile } from 'components/Rop/RopWLFilter/RopWLFilter.mobile'
import { tableStatusBtns } from 'components/Rop/RopWLTable/const'

import { useAuthStore } from 'context/AuthStore'
import { useHomeStoreRop } from 'context/HomeStore/Rop'

import { colorStatusesByCode, OKTELL } from 'constants/deals'
import { useResErrors, useRoutes } from 'hooks'
import { AuthService, SalesService } from 'lib/api'
import { DEAL_VIEW_PATH } from 'routes/constants.routes'
import { useRopStyles } from '../../rop.styles'

export const WlList = () => {
  const classes = useRopStyles()
  const router = useRoutes()
  const { standardCheck } = useResErrors()
  const { authStore } = useAuthStore()

  const {
    homeStore: { approveStatus, wlList, wlCount, wlTab, pagination },
    homeStoreFunc: {
      setApproveStatus,
      setWlTab,
      onPaginationChange,
      getSaleList
    }
  } = useHomeStoreRop()

  const [isManagersListDialogOpen, setIsManagersListDialogOpen] =
    useState(false)
  const [selectedWorksheet, setSelectedWorkSheet] = useState({})
  const [selectedManager, setSelectedManager] = useState()
  const [loading, setLoading] = useState(false)
  const [usersList, setUsersList] = useState([])

  const openManagersList = worksheet => event => {
    event.stopPropagation()
    setSelectedWorkSheet(worksheet)
    setIsManagersListDialogOpen(true)
  }

  function closeManagersList() {
    setIsManagersListDialogOpen(false)
  }

  function handleManagerSelect(event) {
    setSelectedManager(event.target.value)
  }

  async function assignToManager() {
    setLoading(true)

    const { branch, firstName, lastName, username } = selectedManager

    const data = {
      assignTo: username,
      assignToFullName: `${firstName} ${lastName}`,
      branchCode: branch.code,
      id: selectedWorksheet.id
    }

    const response = await SalesService.setAssignTo(data)

    standardCheck(
      response,
      async () => {
        setLoading(false)
        closeManagersList()

        await getSaleList({
          branchCodes: [authStore.user.data.branch.code],
          limit: 10,
          offset: 0,
          statusCodes: [OKTELL]
        })
      },
      () => {}
    )

    setLoading(false)
  }

  const getManagers = async () => {
    try {
      const requestData = {
        isActive: true,
        limit: 300,
        offset: 0,
        projectCode: 'CS_V2',
        roleCode: 'MANAGER',
        branchCode: authStore.user.data.branch.code
      }

      const response = await AuthService.getUsers(requestData)
      setUsersList(response.data.userList)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getManagers()
  }, [])

  return (
    <Grid container>
      <RopWLFilterMobile />

      <Grid item container>
        <Grid item container className={classes.filterTabs}>
          <Grid item container className={classes.tabsScroll}>
            {tableStatusBtns.map((e, i) => {
              const isActive = wlTab === i

              return (
                <Grid key={`table_status_btn_${i}`} item>
                  <AsterButton
                    className={clsx(
                      classes.tableStatusBtn,
                      isActive ? classes.tableStatusBtnActive : ''
                    )}
                    onClick={() => setWlTab(i)}
                  >
                    {e.label}

                    {isActive && (
                      <div className={classes.tableStatusCount}>
                        {wlCount || 0}
                      </div>
                    )}
                  </AsterButton>
                </Grid>
              )
            })}
          </Grid>
        </Grid>

        {wlTab === 1 && (
          <RadioGroup
            style={{ width: '100%' }}
            value={approveStatus}
            onChange={e => setApproveStatus(e.target.value)}
          >
            <Grid item container className={classes.filterTabs}>
              <Grid item xs={6}>
                <FormControlLabel
                  className={classes.customizedCheckbox}
                  value="90"
                  control={<Radio size="small" color="primary" />}
                  label={'Согласовать скидку'}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  className={classes.customizedCheckbox}
                  value="80"
                  control={<Radio size="small" color="primary" />}
                  label={'Согласовать закрытие'}
                />
              </Grid>
            </Grid>
          </RadioGroup>
        )}
      </Grid>

      <Grid item container spacing="4">
        {wlList?.length ? (
          wlList.map(e => (
            <Grid item xs="12">
              <Card onClick={() => router.goTo(`${DEAL_VIEW_PATH}/${e.id}`)}>
                <CardActions>
                  <Grid container>
                    <Grid item container spacing={2}>
                      <Grid item>
                        <AsterChip
                          label={e?.saleStatus?.name}
                          style={{
                            ...colorStatusesByCode(e?.saleStatus?.code)
                          }}
                        />
                      </Grid>

                      <Grid item>
                        <AsterChip
                          label={e?.seoNumber || 'Без талона'}
                          style={{
                            ...colorStatusesByCode(e?.saleStatus?.code)
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs="12"
                      style={{ marginTop: 4, marginBottom: 8 }}
                    >
                      <AsterTypography variant="h6">
                        {[
                          e?.globalId,
                          clsx(e?.client?.firstName, e?.client?.lastName),
                          format(new Date(e?.createdDate), 'dd.MM.yyyy HH:mm')
                        ].join('・')}
                      </AsterTypography>
                    </Grid>

                    <Grid item xs="12">
                      <FieldInfoNG label="VIN-код" isVertical>
                        <AsterTypography style={{ fontSize: 16 }}>
                          {e?.selectedCarVins && e?.selectedCarVins.join(', ')}
                        </AsterTypography>
                      </FieldInfoNG>
                    </Grid>

                    <Grid
                      item
                      xs="12"
                      style={{
                        marginTop: 8,
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <FieldInfoNG label="Сотрудник" isVertical>
                        <AsterTypography style={{ fontSize: 16 }}>
                          {e?.selectedCarVins && e?.assignToFullName}
                        </AsterTypography>
                      </FieldInfoNG>

                      {wlTab === 2 && (
                        <IconButton>
                          <EditIcon onClick={openManagersList(e)} />
                        </IconButton>
                      )}
                    </Grid>

                    <Grid item container spacing={3} style={{ marginTop: 5 }}>
                      <Grid item>
                        <AsterChip
                          icon={
                            /* @todo Нужен подвод */
                            !!e?.podvod ? (
                              <CheckIcon
                                style={{
                                  color: SUCCESS_COLORS[700],
                                  fontSize: 10
                                }}
                              />
                            ) : (
                              <CloseIcon
                                style={{ color: ERROR_COLORS[700], width: 10 }}
                              />
                            )
                          }
                          label="Подвод"
                        />
                      </Grid>

                      <Grid item>
                        <AsterChip
                          icon={
                            !!e?.creditRequest ? (
                              <CheckIcon
                                style={{
                                  color: SUCCESS_COLORS[700],
                                  fontSize: 10
                                }}
                              />
                            ) : (
                              <CloseIcon
                                style={{ color: ERROR_COLORS[700], width: 10 }}
                              />
                            )
                          }
                          label="Трейд-ин"
                        />
                      </Grid>

                      <Grid item>
                        <AsterChip
                          icon={
                            !!e?.isRedirect ? (
                              <CheckIcon
                                style={{
                                  color: SUCCESS_COLORS[700],
                                  fontSize: 10
                                }}
                              />
                            ) : (
                              <CloseIcon
                                style={{ color: ERROR_COLORS[700], width: 10 }}
                              />
                            )
                          }
                          label="Новый контракт"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <NotFound title="Нет РЛ" />
        )}
      </Grid>

      <Grid item container style={{ marginTop: 24 }}>
        <Pagination
          variant="outlined"
          shape="rounded"
          className={classes.pagination}
          count={pagination.count}
          page={pagination.offset ? pagination.offset / 10 : 1}
          onChange={onPaginationChange}
        />
      </Grid>

      <Dialog open={isManagersListDialogOpen} onClose={closeManagersList}>
        <DialogTitle>Назначение РЛ на менеджера</DialogTitle>

        <DialogContent>
          <FormControl>
            <InputLabel>Назначить на</InputLabel>

            <Select
              label="Назначить на"
              style={{
                width: '15em'
              }}
              value={selectedManager}
              onChange={handleManagerSelect}
            >
              {usersList.length > 0 &&
                usersList.map(item => (
                  <MenuItem value={item} key={item.id}>
                    {item.lastName + ' ' + item.firstName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          {loading ? (
            <CircularProgress />
          ) : (
            <Button
              color="primary"
              variant="contained"
              disabled={!selectedManager}
              onClick={assignToManager}
            >
              Назначить
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Grid>
  )
}
